import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'providers/AuthProvider'
import Layout from 'components/Layout/Layout'
import { ROUTES } from './routes'

const PrivateRoute = () => {
  const { getAuthRouteContent } = useAuth()
  const location = useLocation()

  return getAuthRouteContent(
    <Layout />,
    <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  )
}

export default PrivateRoute
